const config = {
  apiUrl: "https://api.sunbit.in",
  apiUrlPci: 'https://api-icp.sunbit.in',
  mixpanelToken: '16a24112985c49a92ed895fc3faf1a5d',
  features: {

  },
};

export default config;



// WEBPACK FOOTER //
// ./src/config/oregon-staging.js